// extracted by mini-css-extract-plugin
export var boldText = "_2z-4";
export var checkboxContainer = "_2z-6";
export var closeIcon = "_2z-i";
export var container = "_2z-0";
export var drawer = "_2z-8";
export var drawerContent = "_2z-9";
export var extraSmallText = "_2z-5";
export var fulfillmentGroupTable = "_2z-e";
export var largeText = "_2z-3";
export var loadingSpinnerContainer = "_2z-j";
export var mediumText = "_2z-2";
export var narrow = "_2z-f";
export var notificationLink = "_2z-l";
export var packageCheckIconContainer = "_2z-7";
export var slideoutHeaderActions = "_2z-g";
export var slideoutHeaderActionsShifted = "_2z-h";
export var slideoutHeaderContainer = "_2z-a";
export var slideoutModal = "_2z-c";
export var stickyHeaderWrapper = "_2z-b";
export var table = "_2z-k";
export var tableContainer = "_2z-d";
export var tertiaryText = "_2z-1";